import { createStore } from "vuex";

import beneficiaryModule from "./modules/beneficiary/index.js";
import deliveryModule from "./modules/delivery/index.js";
import fdModule from "./modules/fd/index.js";
import userModule from "./modules/user/index.js";
import volunteerModule from "./modules/volunteer/index.js";
import eventsModule from "./modules/events/index.js";
import configurationsModule from "./modules/configurations/index.js";
import surveysModule from "./modules/surveys/index.js";
import interestsModule from "./modules/interests/index.js";

const store = createStore({
    modules: {
        beneficiary: beneficiaryModule,
        delivery: deliveryModule,
        fd: fdModule,
        user: userModule,
        volunteer: volunteerModule,
        events: eventsModule,
        configurations: configurationsModule,
        surveys: surveysModule,
        interests: interestsModule
    }
});

export default store;